import {
  dealStatus,
  InvoiceStatus,
  PaymentStatus,
  CollectionStatus,
} from "../../../Enums/dealStatus.Enum";

export const getStatus = (status, defaultValue) => {
  if (!status) return defaultValue;
  if (typeof status === "number") return status;
  switch (status.trim()) {
    case "Draft":
      return dealStatus[1].value;
    case "Posted":
      return dealStatus[2].value;
    case "Approved":
      return dealStatus[3].value;
    case "Submitted":
      return InvoiceStatus[1].value;
    case "NotReady":
      return InvoiceStatus[2].value;
    case "ReadyToReleased":
      return PaymentStatus[2].value;
    case "Pending":
      return PaymentStatus[1].value;
    case "Released":
      return PaymentStatus[3].value;
    case "Paid":
      return CollectionStatus[1].value;
    case "Unpaid":
      return CollectionStatus[2].value;
    default:
      return defaultValue;
  }
};
